import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { AuthProvider } from '@/contexts/auth-context';
import { RootLoader } from '@/components/root-loader';
import { router } from './router';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider>
      <RootLoader>
        <RouterProvider router={router} />
      </RootLoader>
    </AuthProvider>
  </StrictMode>,
);
